import {QuoteCols} from '@sdox/ui'

import type {XcNwBlock_BlockQuotesType_Fragment} from '@sdox/api'

export const BlockQuotes = ({quotes}: XcNwBlock_BlockQuotesType_Fragment) => {
  return <QuoteCols items={quotes.map(text => ({text}))} />
}
